/**
* consultation JS
* -----------------------------------------------------------------------------
*
* All the JS for the consultation component.
*/
( function( app ) {
  const COMPONENT = {

    className: 'll-consultation',


    selector: function() {
      return '.' + this.className;
    },


    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const _this = this;

      const intro = document.querySelector( '.intro' );
      const picker = document.querySelector( '.picker' );
      const form = document.querySelector( '.form-section' );
      const start = document.querySelector( '.vc-start' );
      // console.log( $( '.ll-consultation' ).find( '.vc-start' ) );
      $( '.ll-consultation' ).find( '.vc-start' ).on( 'click', function() {
        intro.classList.add( 'hidden' );
        picker.classList.remove( 'hidden' );
      } );
      const pins = document.querySelectorAll( '.body-pin' );
      let activeModal = null;
      const selectedConcerns = [];
      pins.forEach( function( pin ) {
        pin.addEventListener( 'click', function() {
          const modal = document.querySelector( '.modal[data-key="' + pin.dataset.key + '"]' );
          modal.classList.remove( 'hidden' );
          picker.classList.add( 'is-selecting' );
          activeModal = modal;
        } );
      } );
      const success = document.querySelector( '.success-modal' );
      const modals = document.querySelectorAll( '.concern-modal' );
      modals.forEach( function( modal ) {
        const close = modal.querySelector( '.close-modal' );
        close.addEventListener( 'click', function() {
          modal.classList.add( 'hidden' );
          picker.classList.remove( 'is-selecting' );
        } );
        const addTo = modal.querySelector( '.add-to' );
        addTo.addEventListener( 'click', function() {
          const selected = Array.from( modal.querySelectorAll( 'input:checked' ) ).map( function( concern ) {
            return concern.dataset.val;
          } );
          selectedConcerns.push( modal.dataset.val + ' : ' + selected.join( ', ' ) );
          // console.log( selectedConcerns );
          modal.classList.add( 'hidden' );
          const amount = success.querySelector( 'span.amount' );
          amount.textContent = selected.length;
          success.classList.remove( 'hidden' );
        } );
      } );
      const addMore = document.querySelector( '.add-more' );
      addMore.addEventListener( 'click', function() {
        success.classList.add( 'hidden' );
        picker.classList.remove( 'is-selecting' );
      } );
      success.querySelector( '.close-modal' ).addEventListener( 'click', function() {
        success.classList.add( 'hidden' );
      } );
      const finishBtns = document.querySelectorAll( '.finish' );
      finishBtns.forEach( function( btn ) {
        btn.addEventListener( 'click', function() {
          picker.classList.add( 'hidden' );
          form.classList.remove( 'hidden' );
          document.querySelector( 'input.gform_hidden' ).value = selectedConcerns;
        } );
      } );
    },
    finalize: function() {
      const _this = this;
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'consultation', COMPONENT );
} )( app );
